import React, {
  useContext,
} from 'react';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import {
  WizardContext,
} from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/wizardContext';
import useDiscrepancyData from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/Discrepancy/hook';
import {
  Button,
} from '@populateui/ui';
import ArrowRightIcon from 'core/icons/arrowRight';

export default function DiscrepancySummaryCard() {
  const {
    parsedEOBErrors,
    isDiscrepancyDetailsOpen,
    setIsDiscrepancyDetailsOpen,
  } = useContext(WizardContext);

  const {
    summaryItems,
    totalDiscrepancyCount,
  } = useDiscrepancyData(parsedEOBErrors);

  return totalDiscrepancyCount !== 0 ? (
    <div className="flex flex-col gap-2 bg-white border border-gray-200 rounded-xl p-2">
      <div className="flex items-center gap-2 min-w-0">
        <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
          <ErrorOutlineRoundedIcon className="!w-4 !h-4 !text-gray-600" />
        </div>
        <div className="min-w-0 flex flex-col gap-0">
          <h3 className="text-sm font-semibold text-gray-900 leading-5">
            Claim and EOB data mismatch
          </h3>
        </div>
      </div>
      <div className="flex items-end justify-between">
        <ul className="list-disc pl-5 flex flex-col gap-1">
          {summaryItems.map((item) => (
            <li key={item.key} className="text-xs text-gray-600 font-medium leading-5">
              {item.label}
              {': '}
              <span className="font-semibold">{item.count}</span>
            </li>
          ))}
        </ul>
        <Button
          variant="text"
          color="primary"
          className="!p-0 flex items-center gap-1"
          onClick={() => {
            setIsDiscrepancyDetailsOpen(!isDiscrepancyDetailsOpen);
          }}
        >
          Review discrepancies
          {' '}
          <ArrowRightIcon className="!w-4 !h-4 !text-inherit mt-1" />
        </Button>
      </div>
    </div>
  ) : null;
}
